import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-visit-or-refunds',
  imports: [TranslateModule],
  templateUrl: './visit-or-refunds.component.html',
  styleUrl: './visit-or-refunds.component.scss',
})
export class VisitOrRefundsComponent {}
